import { render } from "./Fancybox.vue?vue&type=template&id=032a2f20"
import script from "./Fancybox.vue?vue&type=script&lang=js"
export * from "./Fancybox.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__